import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-empty-focus',
    templateUrl: './empty-focus.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmptyFocusComponent extends SubscriptionManager {

    shouldDisplayCloseButton = false;

    constructor(private readonly route: ActivatedRoute,
                private readonly cdr: ChangeDetectorRef) {
        super();

        this.route.queryParams.pipe(
            this.untilDestroyed,
            tap(e => {
                this.shouldDisplayCloseButton = +e.closeButton === 1;
                this.cdr.markForCheck();
            })
        ).subscribe();
    }
}
